"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipientType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var RecipientType_Factory = /** @class */ (function () {
    function RecipientType_Factory() {
    }
    RecipientType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    RecipientType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return RecipientType_Factory;
}());
exports.RecipientType_Factory = RecipientType_Factory;
